
import ConfirmChangePrice from './confirmChangePrice.vue'
export default {
    name: 'BuyerConfirmOrderInfo',
    components: {
        ConfirmChangePrice
    },
    props: {
        content: {
            type: Object,
            default: () => ({})
        },
        mentionedUser: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            isShow: false
        }
    },
    methods: {
        goConfirm () {
            this.$refs.confirmChangePriceRef.open()
        }
    }
}
